'use client';

import { c as _c } from "react/compiler-runtime";
import * as SubframeCore from '@subframe/core';
import { FeatherX } from '@subframe/core';
import React from 'react';
import { IconButton } from '@/shared/components/ui/common/IconButton';
interface MobileSidebarDrawerProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}
export const MobileSidebarDrawer: React.FC<MobileSidebarDrawerProps> = t0 => {
  const $ = _c(20);
  const {
    open,
    onClose,
    children
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = nextOpen => !nextOpen ? onClose() : undefined;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose) {
    t2 = <div className="absolute inset-0 bg-black/50" onClick={onClose} />;
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-body-bold font-body-bold text-default-font">Menu</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FeatherX />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onClose) {
    t5 = <div className="flex items-center justify-between border-b border-solid border-neutral-100 px-4 py-3">{t3}<IconButton icon={t4} onClick={onClose} variant="neutral-tertiary" size="small" aria-label="Fechar menu" /></div>;
    $[6] = onClose;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children) {
    t6 = <div className="flex-1 overflow-hidden">{children}</div>;
    $[8] = children;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <SubframeCore.Drawer.Content asChild={true}><div className="bg-default-background absolute inset-y-0 left-0 w-72 max-w-full border-r border-solid border-neutral-100 shadow-lg focus:outline-none"><div className="flex h-full w-full flex-col">{t5}{t6}</div></div></SubframeCore.Drawer.Content>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t7) {
    t8 = <div className="fixed inset-0 z-50 lg:hidden">{t2}{t7}</div>;
    $[13] = t2;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== open || $[17] !== t1 || $[18] !== t8) {
    t9 = <SubframeCore.Drawer.Root open={open} onOpenChange={t1}>{t8}</SubframeCore.Drawer.Root>;
    $[16] = open;
    $[17] = t1;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};